import Sitemap from "./sitemap";

export default Sitemap;